/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const SystemInformationRemoteReadQuery = gql`
  query SystemInformationRemoteRead {
    SystemInformationRemoteRead {
      cpu
      diskInfo
      memory
      message
      serverStatus
      status
    }
  }
`


/*
 * EXPORTS
 */
export default SystemInformationRemoteReadQuery
